import { render, staticRenderFns } from "./Layers.vue?vue&type=template&id=db9b80ba&scoped=true"
import script from "./Layers.vue?vue&type=script&lang=js"
export * from "./Layers.vue?vue&type=script&lang=js"
import style0 from "./Layers.vue?vue&type=style&index=0&id=db9b80ba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db9b80ba",
  null
  
)

export default component.exports